import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { ClaimStatusColor } from '../../ClaimDetailConstants';

export enum ClaimStatusDetailRowState {
  FINISHED,
  INPROGRESS,
  PENDING
}

@Component({
  selector: 'app-claim-status-detail-row',
  templateUrl: './claim-status-detail-row.component.html',
  styleUrls: ['./claim-status-detail-row.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIcon
  ]
})
export class ClaimStatusDetailRowComponent {

  @Input() statusText!: string;
  @Input() state!: ClaimStatusDetailRowState;

  textColor!: string;
  icon!: string;

  getTextColor(): string {
    switch(this.state) {
      case ClaimStatusDetailRowState.FINISHED:
        return ClaimStatusColor.COMPLETED;
      case ClaimStatusDetailRowState.INPROGRESS:
        return ClaimStatusColor.INPROGRESS;
      case ClaimStatusDetailRowState.PENDING:
        return ClaimStatusColor.PENDING;
      default:
        return ClaimStatusColor.PENDING;
    }
  }

  getIcon(): string {
    switch(this.state) {
      case ClaimStatusDetailRowState.FINISHED:
        return 'check_circle';
      case ClaimStatusDetailRowState.INPROGRESS:
        return 'autorenew';
      case ClaimStatusDetailRowState.PENDING:
        return 'more_horiz';
      default:
        return 'more_horiz';
    }
  }
}